import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';
import { useDispatch, useSelector } from 'react-redux';
import { UiKitContextProvider } from '@cian/ui-kit/context';

import { setIsAnonymous } from '../../actions/newAnswer/isAnonymousActions';
import { getIsAnonymous } from '../../selectors/newAnswer';

export const AnonymousContainer = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const isAnonymous = useSelector(getIsAnonymous);

  const onClick = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, value: boolean) => {
      dispatch(setIsAnonymous(value));
    },
    [dispatch],
  );

  return (
    <UiKitContextProvider useStaticDeviceType={true} deviceType="desktop">
      <Checkbox label="Анонимный ответ" checked={isAnonymous} onChange={onClick} />
    </UiKitContextProvider>
  );
};
